import React, { useState } from 'react';
import Layout from '../../common/components/Navbar'; // <--- Imported Layout
import {
  Title,
  Paper,
  Group,
  TextInput,
  Button,
  Stack,
  PasswordInput,
  Tabs,
  Avatar,
  Text,
  Badge,
  Container,
  Alert
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconUser, IconLock, IconInfoCircle } from '@tabler/icons-react';
import Swal from 'sweetalert2';
import axios from '../../api/axios';

const Profile = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);

  const passwordForm = useForm({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    validate: {
      currentPassword: (val) => (val.length < 1 ? 'Current password is required' : null),
      newPassword: (val) => (val.length < 6 ? 'Password must be at least 6 characters' : null),
      confirmPassword: (val, values) => (val !== values.newPassword ? 'Passwords do not match' : null),
    },
  });

  const handlePasswordChange = async (values) => {
    setLoading(true);
    try {
      await axios.put('/api/auth/updatepassword', {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword
      }, {
        headers: { Authorization: `Bearer ${user.token}` }
      });

      Swal.fire('Success', 'Password updated successfully', 'success');
      passwordForm.reset();
    } catch (error) {
      Swal.fire('Error', error.response?.data?.message || 'Failed to update password', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container size="sm">
        <Title order={2} mb="lg">My Profile</Title>

        <Paper shadow="sm" radius="md" withBorder p="xl">
          <Group position="center" mb="xl">
            <Avatar size={120} radius={120} color="teal">
              {user?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <Stack spacing={0} align="center">
              <Text size="xl" weight={700}>{user?.name}</Text>
              <Text c="dimmed">{user?.email}</Text>
              <Badge color="teal" mt="sm" size="lg">{user?.role?.toUpperCase().replace('_', ' ')}</Badge>
            </Stack>
          </Group>

          <Tabs defaultValue="info" color="teal">
            <Tabs.List grow>
              <Tabs.Tab value="info" leftSection={<IconUser size={14} />}>User Info</Tabs.Tab>
              <Tabs.Tab value="security" leftSection={<IconLock size={14} />}>Security</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="info" pt="xs">
              <Stack mt="md">
                <Alert icon={<IconInfoCircle size={16} />} title="Read Only" color="blue" variant="light">
                  Profile details can only be edited by the Administrator.
                </Alert>
                <TextInput 
                  label="Full Name" 
                  value={user?.name || ''} 
                  readOnly 
                  variant="filled" 
                />
                <TextInput 
                  label="Email Address" 
                  value={user?.email || ''} 
                  readOnly 
                  variant="filled" 
                />
                <TextInput 
                  label="Account ID" 
                  value={user?._id || ''} 
                  readOnly 
                  variant="filled" 
                />
              </Stack>
            </Tabs.Panel>

            <Tabs.Panel value="security" pt="xs">
              <form onSubmit={passwordForm.onSubmit(handlePasswordChange)}>
                <Stack mt="md">
                  <PasswordInput
                    label="Current Password"
                    placeholder="Enter current password"
                    required
                    {...passwordForm.getInputProps('currentPassword')}
                  />
                  <PasswordInput
                    label="New Password"
                    placeholder="Enter new password"
                    required
                    {...passwordForm.getInputProps('newPassword')}
                  />
                  <PasswordInput
                    label="Confirm New Password"
                    placeholder="Repeat new password"
                    required
                    {...passwordForm.getInputProps('confirmPassword')}
                  />
                  <Group justify="flex-end" mt="md">
                    <Button type="submit" color="teal" loading={loading}>
                      Update Password
                    </Button>
                  </Group>
                </Stack>
              </form>
            </Tabs.Panel>
          </Tabs>
        </Paper>
      </Container>
    </Layout>
  );
};

export default Profile;